import {
  subDays,
  isSaturday,
  isSunday,
  isMonday,
  subBusinessDays,
} from 'date-fns'
import { PlannedDeliveryStatus } from '~/models/PlannedDelivery/PlannedDelivery'

export function getPuppetProcessingDate(
  nextDeliveryDate?: Date,
): Date | undefined {
  if (!nextDeliveryDate) {
    return undefined
  }

  // Get the day of the week.
  // Depending on the day of the week, calculate the next send date as follows:

  // When the delivery date is wednesday,
  // 1 - The package needs to be on the mail the day before.
  // 2 - The day before the medicines need to be ordered.
  // 3 - The AutoClicker will process the order during the night so the controle has to happen the day before.

  // Default 3 days are needed to process the order and have it delivered on time, but for some days of the week, more days are needed to be sure the medicines are delivered on time.

  // Monday = 5 days earlier due to the weekend
  // Tuesday = 4 days earlier due to the weekend
  // Wednesday = 3 days earlier
  // Thursday = 3 days earlier
  // Friday = 3 days earlier
  // Saturday = 3 days earlier
  // Sunday = 4 days earlier due to the weekend and no deliveries on Sunday

  // With CF it needs to be processed earlier.
  const processingDays = 3 + 1

  let newDeliveryDate = nextDeliveryDate
  if (isSunday(nextDeliveryDate)) {
    // On Sunday no deliveries are done by the postal service, so these will need to delivered on Saturday
    newDeliveryDate = subDays(nextDeliveryDate, 1)
  }
  if (isMonday(nextDeliveryDate)) {
    // No packages are sent on saturday so no deliveries are done by the postal service, so these will need to delivered on saturday
    newDeliveryDate = subDays(nextDeliveryDate, 1)
  }

  const needsToBeProcessedOn = subBusinessDays(newDeliveryDate, processingDays)

  if (isSaturday(needsToBeProcessedOn)) {
    return new Date(subDays(needsToBeProcessedOn, 1))
  }
  else if (isSunday(needsToBeProcessedOn)) {
    return new Date(subDays(needsToBeProcessedOn, 2))
  }

  return new Date(needsToBeProcessedOn)
}

export type PuppetProcessingAction
  = 'UNKNOWN' | 'ALERT' | 'FUTURE' | 'APPROVED' | 'WARNING' | 'SEND'

export function getPuppetProcessingStatus(
  deliveryStatus: PlannedDeliveryStatus,
  today: Date,
  processingDate?: Date,
): PuppetProcessingAction {
  if (!processingDate) {
    return 'UNKNOWN'
  }

  if (deliveryStatus === PlannedDeliveryStatus.ParcelCreated) {
    return 'SEND'
  }

  if (deliveryStatus === PlannedDeliveryStatus.Processing) {
    if (processingDate < today) {
      return 'ALERT' // 'release-alert-rounded'
    }
    if (processingDate > today) {
      return 'FUTURE'
    }
    return 'APPROVED'
  }
  else if (
    deliveryStatus === PlannedDeliveryStatus.Approved
    || deliveryStatus === PlannedDeliveryStatus.Planned
  ) {
    if (processingDate > today) {
      return 'FUTURE' // 'info'
    }
    else if (processingDate < today) {
      return 'ALERT' // 'release-alert-rounded'
    }
    return 'WARNING' // 'warning-rounded'
  }
  else {
    return processingDate <= today ? 'ALERT' : 'FUTURE'
  }
}
